module.exports = __webpack_public_path__ + "92263821a9fe164459cd1195209c6bdd.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/collosal_battles-872.webp.png
// module id = 222
// module chunks = 0